<template>
  <div id="app">
    <transition mode="out-in">
      <router-view />
    </transition>
  </div>
</template>
<script>
export default {
  components: {},
  created() {
    if (window.localStorage.carrinho) {
      this.$store.commit(
        "UPDATE_CART_SESSION",
        JSON.parse(window.localStorage.carrinho)
      );
    }
    if (sessionStorage.userData) {
      this.$store.commit("UPDATE_USER", JSON.parse(sessionStorage.userData));
      setInterval(() => {
        this.$http
          .validate()
          .then((resp) => {
            if (resp.data === true) {
              this.$store.commit(
                "UPDATE_USER",
                JSON.parse(sessionStorage.userData)
              );
            } else {
              this.$store.dispatch("LOGOUT");
              this.$router.push({ name: "login" });
            }
          })
          .catch(() => {
            this.$store.dispatch("LOGOUT");
            this.$router.push({ name: "login" });
          });
      }, 600000);
    }

    //Check internet conection
  },
};
</script>
<style lang="scss"></style>
